import { Component, Input } from '@angular/core';
import { ResInstructionDTO } from 'src/app/core/Dtos/res/instructions-dto';
import { AlertsService } from 'src/app/core/services/alerts.service';
import { DateFormatHelperService } from 'src/app/core/services/date-format-helper.service';
import { ResService } from 'src/app/core/services/res.service';
import { UserService } from 'src/app/core/user.service';
import { ResIntructionType } from 'src/app/core/Dtos/res/instructions-dto';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-res-viewer',
  templateUrl: './res-viewer.component.html',
  styleUrl: './res-viewer.component.scss',
  standalone: false
})
export class ResViewerComponent {
  @Input() public set InstructionId(instructionId: string | number) {
    if (instructionId !== 0)
      this.GetInstruction(instructionId);
    this._instructionId = instructionId;
  };

  public Instruction: ResInstructionDTO = new ResInstructionDTO();
  public ResIntructionType = ResIntructionType;
  public CloseImageData: string = "";
  public CoAssumptionsImageData: string = "";

  private _closeImage: File | null = null;
  private _coAssumptionsImage: File | null = null;
  private _instructionId: string | number = '';

  constructor(
    private _resService: ResService,
    private _alertService: AlertsService,
    public DateFormatHelper: DateFormatHelperService,
    public UserService: UserService) {
  }

  GetInstruction(instructionId: string | number) {
    this._resService.GetInstructionById(instructionId).subscribe(
      resp => {
        this.Instruction = resp;
      }
    )
  }

  ChangeStatus(status: string) {
    this._resService.ChangeStatus(this._instructionId, status).subscribe(
      resp => {
        this.GetInstruction(this._instructionId);
      }
    )
  }

  Formatext(text: string): string {
    if (!text) {
      return '';
    }
    return text
      .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;') // Replace \t with tabs
      .replace(/\n/g, '<br/>'); // Replace \n with <br/>
  }

  DownloadFile(fileType: string) {
//    this._resService.DownloadFile(+fileId).subscribe(
//      response => {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.style.display = 'none';

        /*
        const contentType = response.headers.get('Content-Type') || 'application/octet-stream';
        const contentDisposition = response.headers.get('Content-Disposition');

        let filename = 'default-file';
        if (fileName) {
          filename = fileName;
        }

        //create a blob from the response body
        const blob = new Blob([response.body], { type: contentType });
        const url = window.URL.createObjectURL(blob);
      */
        //set the download URL  and filename
        if (fileType === 'closeImage') {
          a.href = this.CloseImageData;
        } else {
          a.href = this.CoAssumptionsImageData;
        }
        a.download = fileType;
        a.click();

        //clean up url object
        // window.URL.revokeObjectURL(url);
/*      },
      err => {
        this._alertService.ShowAlert(err);
      }
    )
*/
  }
}